import { Crosshair, Swords, Skull, Gamepad2 } from "lucide-react";

export const GAME_CATEGORIES = [
  {
    id: "shooters",
    name: "SHOOTERS & COMPETITIVE",
    tagline: "Aim. Frag. Repeat.",
    icon: Crosshair,
    accent: "text-yellow-400",
    games: [
      "Counter-Strike 2",
      "Valorant",
      "Apex Legends",
      "Call of Duty: Warzone",
      "PLAYERUNKNOWN'S BATTLEGROUNDS",
      "Overwatch 2",
      "Counter-Strike 1.6 / Source",
      "Arena Breakout: Infinite",
      "Quake III: Arena",
      "Unreal Tournament 2004",
      "Phasmophobia",
      "FACEIT Platform",
    ],
  },
  {
    id: "mmo",
    name: "MMORPG, MOBA & ACTION RPG",
    tagline: "Level up your legend.",
    icon: Swords,
    accent: "text-green-400",
    games: [
      "League of Legends",
      "World of Warcraft",
      "DOTA 2",
      "Diablo IV",
      "Hearthstone",
      "Heroes of the Storm",
      "Genshin Impact",
      "Warframe",
      "Arc Raiders",
    ],
  },
  {
    id: "survival",
    name: "ACTION, SURVIVAL & SANDBOX",
    tagline: "Build. Survive. Escape.",
    icon: Skull,
    accent: "text-red-400",
    games: [
      "Grand Theft Auto V / FiveM",
      "Rust",
      "Minecraft",
      "Roblox",
      "Dead by Daylight",
      "Left 4 Dead 2",
      "Resident Evil Requiem",
      "Among Us",
      "Starship Troopers: Extermination",
      "Aliens vs Predator",
    ],
  },
  {
    id: "arcade",
    name: "SIMULATION, RACING & ARCADE",
    tagline: "Push the throttle.",
    icon: Gamepad2,
    accent: "text-yellow-400",
    games: [
      "Forza Horizon 5",
      "Rocket League",
      "World of Tanks",
      "World of Warplanes",
      "World of Warships",
      "War Thunder",
      "Star Citizen",
      "The Planet Crafter",
      "StarRupture",
      "Species Unknown / MECCHA CHAMELEON",
      "Cuphead",
      "Overcooked! 2",
      "Enter the Gungeon",
    ],
  },
];
